import { createSlice } from '@reduxjs/toolkit';

export const sipTrunk = createSlice({
    name: 'siptrunk',
    initialState: {
        trunkInfo: '',
        didNumbers: [],
        providerIp: '',
        viewTrunkId: '',
        editTrunkId: '',
    },
    reducers: {
        setTrunkInfo: (state, action) => {
            state.trunkInfo = action.payload;
        },
        setDidNumber: (state, action) => {
            state.didNumbers = action.payload;
        },
        setProviderIp: (state, action) => {
            state.providerIp = action.payload;
        },
        setViewTrunkId: (state, action) => {
            state.viewTrunkId = action.payload;
        },
        setEditTrunkId: (state, action) => {
            state.editTrunkId = action.payload;
        },
    }
});

export const {
    setTrunkInfo,
    setDidNumber,
    setProviderIp,
    setViewTrunkId,
    setEditTrunkId
} = sipTrunk.actions

export default sipTrunk.reducer;